export const allowedBackButtonRoutes = [
  'participants',
  'groups',
  'educatorArea',
  'search',
];
